/*
 * Helper class for enums
 */
export class EnumHelper {
  /**
   * Get all values of an enumF
   **/

  static values<T>(enum_: any, exclude?: T[]): T[] {
    const keys = Object.keys(enum_);
    const values: T[] = [];
    for (let index = 0; index < keys.length; index++) {
      if (exclude) {
        let isExcluded = false;
        for (const excludeEnum of exclude) {
          if (excludeEnum == enum_[keys[index] as keyof T]) {
            isExcluded = true;
            break;
          }
        }
        if (!isExcluded) {
          values.push(enum_[keys[index] as keyof T] as T);
        }
      } else {
        values.push(enum_[keys[index] as keyof T] as T);
      }
    }
    return values;
  }
}
